import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import { navigate } from 'js/services/Network';
import * as clipboard from 'clipboard-polyfill';

import Icon from './Icon';
import SVGIcon from './SVGIcon';

import LinkButton from './LinkButton';
import NormalButton from './NormalButton';

import { buttonHeight, lineHeight, verticalPadding, horizontalPadding } from './style';
export { buttonHeight, lineHeight, verticalPadding, horizontalPadding };

function noop() {}

@observer
export default class Button extends Component {
  @observable
  wasClicked = false;

  @action
  setWasClicked(wasClicked) {
    this.wasClicked = wasClicked;
  }

  onClick = event => {
    this.setWasClicked(true);
    const beforeResult = (this.props.before || noop)();

    if (this.props.href || this.props.to) {
      this.props.target !== '_blank' && event.preventDefault();
    } else if (this.props.copy) {
      clipboard.writeText(this.props.copy);
    }

    if (beforeResult && typeof beforeResult.then === 'function') {
      beforeResult.then(() => this.parentOnClick(event));
    } else {
      this.parentOnClick(event);
    }

    this.props.to && navigate(this.props.to);
  };

  parentOnClick = event => {
    const onClickResult = (this.props.onClick || noop)(event);
    if (!this.props.onClick && onClickResult !== false && this.props.href && this.props.target !== '_blank') {
      location.href = typeof onClickResult === 'string' ? onClickResult : this.props.href;
    }
  };

  renderIcon = () => {
    const { icon, iconFloat, children } = this.props;
    if (icon) {
      return icon.endsWith('.svg') ? (
        <SVGIcon src={icon} side={children ? iconFloat || 'left' : null} />
      ) : (
        <Icon name={icon} side={children ? iconFloat || 'left' : null} />
      );
    }
    return false;
  };

  render() {
    let { children, onClick, isLoading, noState, ...rest } = this.props;
    const iconFloat = this.props.iconFloat || 'left';

    if (this.props.href || this.props.to) {
      isLoading =
        isLoading ||
        (this.props.href && this.props.target !== '_blank' && !this.props.href.match(/^mailto/) && this.wasClicked);
      return (
        <LinkButton isLoading={!noState && isLoading} onClick={this.onClick} {...rest}>
          {iconFloat === 'left' && this.renderIcon()}
          {children}
          {iconFloat === 'right' && this.renderIcon()}
        </LinkButton>
      );
    } else if (this.props.copy) {
      return (
        <NormalButton onClick={this.onClick} {...rest}>
          {iconFloat === 'left' && this.renderIcon()}
          {this.wasClicked || this.props.wasCopied ? this.props.copiedLabel || children : children}
          {iconFloat === 'right' && this.renderIcon()}
        </NormalButton>
      );
    } else {
      return (
        <NormalButton isLoading={!noState && isLoading} onClick={this.onClick} {...rest}>
          {iconFloat === 'left' && this.renderIcon()}
          {children}
          {iconFloat === 'right' && this.renderIcon()}
        </NormalButton>
      );
    }
  }
}
